import { config } from '@/src/config/app-config';
import { Challenge } from '@/src/types/Challenge';
import { Nullable } from '@/src/types/common';
import { ChallengeType, UpdateArenaDefinitionInput } from '@amzn/aws-jam-typescript-client';

export type ArenaDefinitionUpdate = Omit<UpdateArenaDefinitionInput, 'challengeId' | 'lastKnownVersion'>;
export type SaveArenaDefinition = (update: ArenaDefinitionUpdate) => Promise<boolean>;

export const ARENA_MIN_DIMENSIONS = 2;
export const ARENA_MAX_DIMENSIONS = 8;
export const ARENA_TOTAL_WEIGHT = 100;

export const isArenaChallenge = (challenge: Nullable<Challenge> | undefined): boolean => {
  if (!config.ff.enableArena) {
    return false;
  }

  return challenge?.props.challengeType === ChallengeType.SCENARIO;
};
